/* import __COLOCATED_TEMPLATE__ from './track-handling-time.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
/**
 * This component triggers resume/pause events when a conversation is viewed.
 * Phase 1: Console logging only to establish the tracking foundation.
 */

import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type Conversation from 'embercom/objects/inbox/conversation';
import type ConversationHandlingService from 'embercom/services/conversation-handling-service';
import type Router from '@ember/routing/router-service';

interface Args {
  conversation: Conversation;
}

interface Signature {
  Args: Args;
  Element: HTMLDivElement;
}

export default class TrackHandlingTime extends Component<Signature> {
  @service declare conversationHandlingService: ConversationHandlingService;
  @service declare router: Router;

  private lastCheckedConversationId: number | null = null;

  get isRouteValid(): boolean {
    // We only want to track handling time on the inbox routes
    return this.router.currentRouteName.includes('inbox.workspace.inbox');
  }

  @action
  handleConversationHandling() {
    this.conversationHandlingService.resumeConversation(this.args.conversation);
    this.lastCheckedConversationId = this.args.conversation.id;
  }

  @action
  onConversationChange(_element: Element, [conversationId]: [number]) {
    if (this.lastCheckedConversationId === conversationId) {
      return;
    }

    this.handleConversationHandling();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Conversation::TrackHandlingTime': typeof TrackHandlingTime;
    'inbox2/conversation/track-handling-time': typeof TrackHandlingTime;
  }
}
